module.exports = __webpack_public_path__ + "static/img/1.1e20afd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/1.jpg
// module id = dK6J
// module chunks = 1